module.exports = __webpack_public_path__ + "7237d8f24807b1871866405c7a9b036f.png";